import actionTypes from "../actionTypes";
import { messageService } from "../../dialpad/service";
import globalAction from "./global.action";
import profileAction from "./profile.action";
import callAction from "./call.action";
import onlineAction from "./online.action";
import { buildMessage } from "../helper/call.helper";
import MessageHelper from "../helper/message.helper";
import CommonManager from "../../helpers/common";
import APIManager from "modules/common/apiManager";
import { localStore } from "helpers";
const { v4: uuidv4 } = require("uuid");
const commonManager = new CommonManager();
const apiManager = new APIManager();

let ringingState = [
  "AGENT_CONNECTING",
  "AGENT_CONNECTED",
  "CUSTOMER_CONNECTING",
  "CUSTOMER_RINING",
];
let bridgeEventList = [
  "BRIDGE_AGENT_INIT",
  "BRIDGE_AGENT_VERIFY_OTP",
  "BRIDGE_AGENT_CONNECTING",
  "BRIDGE_AGENT_RINING",
  "BRIDGE_AGENT_CONNECTED",
  "BRIDGE_AGENT_DISCONNECTED",
];
let callEventList = [
  "connecting",
  "agentRigning",
  "AGENT_CONNECTING",
  "AGENT_CONNECTED",
  "AGENT_RINING",
  "CUSTOMER_CONNECTING",
  "CUSTOMER_RINING",
  "CUSTOMER_CONNECTED",
  "AGENT_DISCONNECTED",
  "CONNECTED",
  "CUSTOMER_DISCONNECTED",
  "TRANSFER_TALK",
  "TRANSFER_START",
  "TRANSFER_CALL",
  "AGENT_MUTE",
  "AGENT_UNMUTE",
  "AGENT_HOLD",
  "AGENT_UNHOLD",
  "ACW",
];
global.__disposeTime = "";
global.__previewTimer = "";
const configProcessor = (type, data) => {
  data = data || {};

  if (type === "pauseList") {
    let configInfo = {
      pattern: "break:list",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "break:list",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "tagList") {
    let configInfo = {
      pattern: "team:tag:list",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "team:tag:list",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "messageTagList") {
    const teamIds = data.teamId || [];

    teamIds.forEach(teamId => {
      let configInfo = {
        pattern: "team:tag:list",
        type: "callHandler",
        body: {
          limit: 20,
          page_no: 1,
          teamId: teamId, // Send teamId as a string
        },
        subtype: "message:team:tag:list",
        replayTo: "notification-to-ui",
      };
      configInfo = buildMessage(configInfo);
      messageService.emitSocketMessage(`message-processor`, configInfo);
    });
  }

  else if (type === "goOnline") {
    let configInfo = {
      pattern: "chat:user:state",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:user:state",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "sendPayload") {
    let configInfo = {
      pattern: "chat:send:payload",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:send:payload",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "chatInboundBlock") {
    let configInfo = {
      pattern: "chat:inbound:block",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:inbound:block",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "liveChatSummary") {
    let configInfo = {
      pattern: "chat:analytics",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "chat:analytics",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "chatHangup") {
    let configInfo = {
      pattern: "chat:hangup",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:hangup",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "dispose") {
    let configInfo = {
      pattern: "chat:send:payload",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:send:payload",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "getHistory") {
    let configInfo = {
      pattern: "chat:fetch:list",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:fetch:list",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "getAssistHistory") {
    let configInfo = {
      pattern: "chat:fetch:list",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:fetch:list",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "getAgentCurrentState") {
    let configInfo = {
      pattern: "chat:agent:current:state",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:agent:current:state",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "contactList") {
    let configInfo = {
      pattern: "contact-list:detail",
      type: "contactHandler",
      body: {
        ...data,
      },
      subtype: "contact-list:detail",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
    console.trace(`iframeEvent contactList ---`);
  } else if (type === "customerComments") {
    let configInfo = {
      pattern: "customer:comments",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "customer:comments",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "contactListUpdate") {
    let configInfo = {
      pattern: "contact-list:data:assign",
      type: "contactHandler",
      body: {
        ...data,
      },
      subtype: "contact-list:data:assign",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "liveMonitor") {
    let configInfo = {
      pattern: "user:list",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype:
        data.transfer && data.transfer == "AGENT"
          ? "transfer:list"
          : "livemonitor:list",
      mainType: "livemonitor:list",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "liveSubscriber") {
    let configInfo = {
      pattern: "user:subscription",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "subscribe",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "liveMonitorData") {
    let configInfo = {
      pattern: "user:live:monitor",
      type: "callHandler",
      body: {
        teamId: [],
      },
      subtype: "user:live:monitor",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "recentCalls") {
    let configInfo = {
      pattern: "user:resents",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
      },
      subtype: "user:resents",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "previewLead") {
    let configInfo = {
      pattern: "team:preview:lead",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
      },
      subtype: "team:preview:lead",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "previewSkip") {
    let configInfo = {
      pattern: "team:preview:skip",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "team:preview:skip",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "previewCont") {
    let configInfo = {
      pattern: "team:preview:count",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "team:preview:count",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
    configProcessor(`notification:count`);
  } else if (type === "teamList") {
    let configInfo = {
      pattern: "user:teams",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        userId: commonManager.getUserId(),
      },
      subtype: "user:teams",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "updatePhoneType") {
    let configInfo = {
      pattern: "user:Update",
      type: "callHandler",
      body: {
        phoneType: data.phoneType,
      },
      subtype: "user:Update",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "forcelogout") {
    let configInfo = {
      pattern: "user:forcelogout",
      type: "callHandler",
      body: {
        userId: data.id,
      },
      subtype: "user:forcelogout",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo, true);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "useHere") {
    messageService.emitSocketMessage(`message-processor`, {
      type: "useHere",
      user_id: data.id,
    });
  } else if (type === "callback:scedule") {
    let configInfo = {
      pattern: "callback:scedule",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "callback:scedule",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "notification:list") {
    let configInfo = {
      pattern: "notification:list",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "notification:list",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
    // dispatch(globalAction.dynamicUpdate({ data  : {"key":"cbListLoading",value : false } }));
  } else if (type === "notification:count") {
    let configInfo = {
      pattern: "notification:count",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "notification:count",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
    // dispatch(globalAction.dynamicUpdate({ data  : {"key":"cbListLoading",value : false } }));
  } else if (type === "dnc:add") {
    let configInfo = {
      pattern: "dnc:add",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "dnc:add",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "schedule:delete") {
    let configInfo = {
      pattern: "schedule:delete",
      type: "callHandler",
      body: {
        ...data,
      },
      subtype: "schedule:delete",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  } else if (type === "getCannedMessages") {
    let configInfo = {
      pattern: "chat:fetch:canned:messages",
      type: "callHandler",
      body: {
        limit: 20,
        page_no: 1,
        ...data,
      },
      subtype: "chat:fetch:canned:messages",
      replayTo: "notification-to-ui",
    };
    configInfo = buildMessage(configInfo);
    messageService.emitSocketMessage(`message-processor`, configInfo);
  }
};
export default {
  /**
   * fetch API with Axios
   */
  fetchMoreMessage: (currentMessageData) => async (dispatch) => {
    dispatch({
      type: actionTypes.MESSAGE_FETCH_MORE,
    });
    try {
      const response = await messageService.fetchMoreMessage(
        currentMessageData
      );
      const { data } = response;
      dispatch({
        type: actionTypes.MESSAGE_FETCH_MORE_SUCCESS,
        payload: data,
      });
    } catch (err) {
      const { data } = err.response;
      dispatch({
        type: actionTypes.ERROR_MESSAGE,
        payload: data.meta.message,
      });
    }
  },

  /**
   * Web Socket with Socket.io
   */
  emitSocketMessage: (type, messageData) => () => {

    messageService.emitSocketMessage(type, messageData);
  },

  socketState: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.GLOBAL_SOCKET_STATE,
      payload: data,
    });
  },

  offlineState: (data) => (dispatch) => {
    dispatch({
      type: actionTypes.IS_OFFLINE,
      payload: data,
    })
  },

  // pass in dispatch, let socket.io dispatch dispatchReceivedMessage when data is received
  receiveSocketMessage: (config) => (dispatch) => {
    messageService.receiveSocketMessage(dispatch, config);
  },
  destroyPhone: (type, data) => (dispatch, getState) => {
    messageService.registerUser(dispatch, type, data, getState);
  },
  registerUser: (type, data) => (dispatch, getState) => {
    messageService.registerUser(dispatch, type, data, getState);
  },
  tagProcess: (type, data) => (dispatch) => {
    messageService.tagProcess(dispatch, type, data);
  },
  configProcessor: (type, data) => (dispatch) => {
    configProcessor(type, data);
  },
  dispatchReceivedMessage: (data) => (dispatch, getState) => {
    if (data.type == "getCallList") {
      dispatch(onlineAction.setCallList({ data: data.callList }));
    } else if (data.type == "stateHandler") {
      if (data.data && data.data.State) {
        dispatch(globalAction.userState({ data: data.data }));
        let State = data.data.State;
        let mainType = data.data.mainType || "";
        let isBridge =
          data.data &&
            data.data.extraData &&
            data.data.extraData &&
            data.data.extraData.isBridgeCall
            ? true
            : false;
        if (bridgeEventList.indexOf(State) > -1) {
          let dtmf =
            data.data &&
              data.data.extraData &&
              data.data.extraData &&
              data.data.extraData.dtmf
              ? data.data.extraData.dtmf
              : "- - - -";
          if (State == "BRIDGE_AGENT_CONNECTED") {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "bridgeState", value: "connecting" },
              })
            );
            if (dtmf) {
              dispatch(
                globalAction.dynamicUpdate({
                  data: { key: "bridgeStateOTP", value: dtmf },
                })
              );
            }
          } else if (State == "BRIDGE_AGENT_RINING") {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "bridgeState", value: "connecting" },
              })
            );
            if (dtmf) {
              dispatch(
                globalAction.dynamicUpdate({
                  data: { key: "bridgeStateOTP", value: dtmf },
                })
              );
            }
          } else if (State == "BRIDGE_AGENT_VERIFY_OTP") {
            // dispatch(globalAction.dynamicUpdate({ data  : {"key":"bridgeState",value : "connecting"} }));
            // if( dtmf ){
            //   dispatch(globalAction.dynamicUpdate({ data  : {"key":"bridgeStateOTP",value : dtmf} }));
            // }
            setTimeout(() => {
              let message = {
                type: "stateHandler",
                state: "online",
                subState: "",
                addTag: true,
                stateInfo: "",
              };
              messageService.emitSocketMessage(`message-processor`, message);
            }, 200);
          } else if (State == "BRIDGE_AGENT_DISCONNECTED") {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "bridgeState", value: "disconnect" },
              })
            );
            if (dtmf) {
              dispatch(
                globalAction.dynamicUpdate({
                  data: { key: "bridgeStateOTP", value: dtmf },
                })
              );
            }
          }
        } else if (callEventList.indexOf(State) > -1 || mainType == "call") {
          dispatch(globalAction.tabState({ data: "online" }));
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "selectedTag", value: [] },
            })
          );
          dispatch(globalAction.callState({ data: true }));

          if (State == "TRANSFER_START") {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callTab", value: "TRANSFER_LIST" },
              })
            );
          } else if (State == "BOT_TRANSCRIPTION") {
            const transcription = data && data.data && data.data.extraData && data.data.extraData.transcription ? data.data.extraData.transcription : [];
            dispatch(
              callAction.setTranscription({
                data: transcription,
              })
            );
            // send transcript 
            MessageHelper.sendTranscript(data.data.extraData);
          } else if (State == "LIVE_CONVERSATON_ANALYTICS") {
            const summary = data && data.data ? data.data : {};
            dispatch(
              callAction.setSummary({
                data: summary,
              })
            );
          } else if (State == "TRANSFER_TALK") {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callTab", value: "TRANSFER_AGENT" },
              })
            );
          } else {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callTab", value: "call" },
              })
            );
            if (State == "AGENT_CONNECTING") {
              MessageHelper.agentConnecting(dispatch, getState, data);
            }
          }
          if (ringingState.indexOf(State) > -1) {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "ringing", value: true },
              })
            );
          } else {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "ringing", value: false },
              })
            );
          }
          if (State == "connecting") {
            // State: "connecting"
            // if( data.call ){
            // }
          } else if (State == "CONNECTED") {
            let extraData = data.data.extraData || {};
            if (
              data.monitorCall == "Monitor" ||
              data.transferCall == "Transfer"
            ) {
              let customerNumber = "";
              if (extraData.callType == "callAndConnect") {
                if (extraData.call2 && extraData.call2.number) {
                  customerNumber = extraData.call2.number;
                }
              } else {
                if (extraData.call1 && extraData.call1.number) {
                  customerNumber = extraData.call1.number;
                }
              }
              dispatch(
                callAction.setCallCustomerNumber({ data: customerNumber })
              );
              dispatch(
                globalAction.dynamicUpdate({
                  data: { key: "custInfo", value: {} },
                })
              );
              if (extraData.team && extraData.team.id) {
                if (data.transferCall == "Transfer") {
                  configProcessor(`contactList`, {
                    teamId: extraData.team.id,
                    mobileNumber: customerNumber,
                  });
                  configProcessor(`tagList`, { teamId: extraData.team.id });
                  configProcessor(`customerComments`, {
                    teamId: extraData.team.id,
                    mobileNumber: customerNumber,
                    limit: 10,
                    page_no: 1,
                  });
                  // iframe event pushed
                  try {
                    MessageHelper.iframeEvent("softphoneCallInvited", {
                      "from": {
                        "number": customerNumber,
                      }
                    });
                  } catch (error) {
                    console.log(`iframeEvent error softphoneCallInvited`, error);
                  }
                }
                dispatch(
                  globalAction.dynamicUpdate({
                    data: { key: "callTeam", value: extraData.team },
                  })
                );
              }
              if (extraData.call1 && extraData.call1.callerId) {
                dispatch(
                  globalAction.dynamicUpdate({
                    data: { key: "callerId", value: extraData.call1.callerId },
                  })
                );
              }
              // if ( data.transferCallData ){
              //   dispatch(globalAction.userState({ data: data.transferCallData }))
              // }
              // else if( data.monitorCallData ) {
              //   dispatch(globalAction.userState({ data: data.monitorCallData }))
              // }
              dispatch(
                callAction.setCallInfo({
                  data: data,
                  userId: commonManager.getUserId(),
                })
              );
              dispatch(
                globalAction.dynamicUpdate({
                  data: { key: "isWidgetOpen", value: true },
                })
              );
            } else if (extraData.callType != "callAndConnect") {
              if (extraData.call1 && extraData.call1.number) {
                dispatch(
                  callAction.setCallCustomerNumber({
                    data: extraData.call1.number,
                  })
                );
                dispatch(
                  globalAction.dynamicUpdate({
                    data: { key: "custInfo", value: {} },
                  })
                );
                dispatch(
                  globalAction.dynamicUpdate({
                    data: { key: "comments", value: [] },
                  })
                );
                if (extraData.team && extraData.team.id) {
                  configProcessor(`contactList`, {
                    teamId: extraData.team.id,
                    mobileNumber: extraData.call1.number,
                  });
                  // iframe event pushed
                  try {
                    MessageHelper.iframeEvent("softphoneCallInvited", {
                      "from": {
                        "number": extraData.call1.number,
                      }
                    });
                  } catch (error) {
                    console.log(`iframeEvent error softphoneCallInvited`, error);
                  }
                  configProcessor(`tagList`, { teamId: extraData.team.id });
                  configProcessor(`customerComments`, {
                    teamId: extraData.team.id,
                    mobileNumber: extraData.call1.number,
                    limit: 10,
                    page_no: 1,
                  });
                }
                dispatch(
                  globalAction.dynamicUpdate({
                    data: { key: "callTeam", value: extraData.team },
                  })
                );
              }
              if (extraData.call1 && extraData.call1.callerId) {
                dispatch(
                  globalAction.dynamicUpdate({
                    data: { key: "callerId", value: extraData.call1.callerId },
                  })
                );
              }
              dispatch(
                callAction.setCallInfo({
                  data: data,
                  userId: commonManager.getUserId(),
                })
              );
            }
          } else if (State == "AGENT_DISCONNECTED" || State == "ACW") {
            data.data.State = "ACW";
            try {
              MessageHelper.musicPause();
            } catch (ex) { }
            if (data.monitorCall && data.monitorCall == "Monitor") {
              setTimeout(() => {
                let message = {
                  type: "stateHandler",
                  state: "online",
                  subState: "",
                  addTag: true,
                  stateInfo: "",
                };
                messageService.emitSocketMessage(`message-processor`, message);
              }, 200);
            } else {
              let tData = {};
              try {
                tData = { ...data };
              } catch (error) { }
              let tInfo = tData.extraData || {};
              // check force dispose or not
              let forceDispose = MessageHelper.checkForceDispose(
                dispatch,
                getState,
                tData
              );
              if (forceDispose) {
                MessageHelper.agentOfferDispose(dispatch, getState, data);
              } else {
                clearInterval(global.__disposeTimer);
                global.__disposeTime = "";
                let { team, teamId } = MessageHelper.getTeam(getState, tInfo);
                if (team.autoDispose && team.disposeTimeout) {
                  MessageHelper.autoDisposeStart(dispatch, getState, team);
                } else {
                  dispatch(
                    globalAction.dynamicUpdate({
                      data: { key: "disposeTimer", value: "" },
                    })
                  );
                }
                dispatch(globalAction.userState({ data: data.data }));
                dispatch(
                  callAction.setCallInfo({
                    data: data,
                    userId: commonManager.getUserId(),
                  })
                );
              }
            }
          } else {
            dispatch(
              callAction.setCallInfo({
                data: data,
                userId: commonManager.getUserId(),
              })
            );
          }

          if (State == "AGENT_MUTE" || State == "MUTE") {
            try {
              clearTimeout(global.__btnTimer);
            } catch (error) {
            }
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callHandlingState", value: "mute" },
              })
            );
          } else if (State == "AGENT_HOLD" || State == "HOLD") {
            try {
              clearTimeout(global.__btnTimer);
            } catch (error) {
            }
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callHandlingState", value: "hold" },
              })
            );
          } else if (State == "TRANSFER_START") {
            try {
              clearTimeout(global.__btnTimer);
            } catch (error) {
            }
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callHandlingState", value: "transfer" },
              })
            );
          } else {
            try {
              clearTimeout(global.__btnTimer);
            } catch (error) {
            }
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "callHandlingState", value: "" },
              })
            );
          }
          if (data.isFirstTime) {
            dispatch(
              callAction.setCallInfo({
                data: data,
                userId: commonManager.getUserId(),
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "isDuplicatePage", value: false },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "isMaxUser", value: false },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "isDuplicateProcess", value: false },
              })
            );
            if (data.data && data.data.extraData) {
              let extraData = data.data.extraData;
              if (extraData.team && extraData.team.id) {
                // dispatch(profileAction.setTeam({ team: {_id: extraData.team.id, name: extraData.team.name || ""} }));
                // dispatch(globalAction.dynamicUpdate({ data  : {"key":"teamName", value : extraData.team.name || "" } }));
                configProcessor(`tagList`, { teamId: extraData.team.id });
              }
              if (extraData.callType == "inboundCall") {
                if (extraData.call1 && extraData.call1.number) {
                  dispatch(
                    callAction.setCallCustomerNumber({
                      data: extraData.call1.number,
                    })
                  );
                  dispatch(callAction.setCallCustomerName({ data: "No Name" }));
                  if (extraData.team && extraData.team.id) {
                    configProcessor(`contactList`, {
                      teamId: extraData.team.id,
                      mobileNumber: extraData.call1.number,
                    });
                    configProcessor(`tagList`, { teamId: extraData.team.id });
                    configProcessor(`customerComments`, {
                      teamId: extraData.team.id,
                      mobileNumber: extraData.call1.number,
                      limit: 10,
                      page_no: 1,
                    });
                    dispatch(
                      globalAction.dynamicUpdate({
                        data: { key: "callTeam", value: extraData.team },
                      })
                    );
                    // iframe event pushed
                    try {
                      MessageHelper.iframeEvent("softphoneCallInvited", {
                        "from": {
                          "number": extraData.call1.number,
                        }
                      });
                    } catch (error) {
                      console.log(`iframeEvent error softphoneCallInvited`, error);
                    }
                  }
                  if (extraData.call1 && extraData.call1.callerId) {
                    dispatch(
                      globalAction.dynamicUpdate({
                        data: {
                          key: "callerId",
                          value: extraData.call1.callerId,
                        },
                      })
                    );
                  }
                }
              } else {
                if (extraData.call2 && extraData.call2.number) {
                  dispatch(
                    callAction.setCallCustomerNumber({
                      data: extraData.call2.number,
                    })
                  );
                  if (extraData.team && extraData.team.id) {
                    configProcessor(`contactList`, {
                      teamId: extraData.team.id,
                      mobileNumber: extraData.call2.number,
                    });
                    configProcessor(`customerComments`, {
                      teamId: extraData.team.id,
                      mobileNumber: extraData.call2.number,
                      limit: 10,
                      page_no: 1,
                    });
                    dispatch(
                      globalAction.dynamicUpdate({
                        data: { key: "callTeam", value: extraData.team },
                      })
                    );
                    try {
                      MessageHelper.iframeEvent("softphoneCallInvited", {
                        "from": {
                          "number": extraData.call2.number,
                        }
                      });
                    } catch (error) {
                      console.log(`iframeEvent error softphoneCallInvited`, error);
                    }
                  }
                  if (extraData.call1 && extraData.call1.callerId) {
                    dispatch(
                      globalAction.dynamicUpdate({
                        data: {
                          key: "callerId",
                          value: extraData.call1.callerId,
                        },
                      })
                    );
                  }
                }
              }
              dispatch(callAction.setCallCustomerName({ data: "No Name" }));
              if (extraData.transcription) {
                dispatch(
                  callAction.setTranscription({
                    data: extraData.transcription,
                  })
                );
              }
            } else {
            }
          }
        } else {
          if (State == "break") {
            dispatch(globalAction.tabState({ data: "online" }));
          } else if (State == "online") {
            dispatch(globalAction.tabState({ data: "online" }));
            try {
              clearTimeout(global.__btnTimer);
            } catch (error) {
            }
            configProcessor(`previewCont`);
            setTimeout(() => {
              configProcessor(`recentCalls`, "");
            }, 500);
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "timerText", value: "" },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "microPhoneState", value: "" },
              })
            );

            try {
              clearTimeout(global.__btnTimer);
            } catch (error) {
            }
          } else if (State == "offline") {
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "bridgeState", value: "" },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "bridgeStateOTP", value: "" },
              })
            );
            const { currentUser } = getState().globalStateReducer;
            if (currentUser && currentUser.phoneType == "bridge") {
              dispatch(callAction.process("bridgeHungup", {}));
            }
          } else if (State == "preview") {
            clearTimeout(global.__previewTimer);
            global.__previewTimer = setTimeout(() => {
              configProcessor(`previewLead`);
            }, 500);
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "custInfo", value: {} },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "comments", value: [] },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "isPreviewLoad", value: true },
              })
            );
            dispatch(
              globalAction.dynamicUpdate({
                data: { key: "isPreviewDial", value: true },
              })
            );
          } else {
          }
          dispatch(globalAction.callState({ data: false }));
          try {
            clearInterval(global.__disposeTimer);
          } catch (error) { }
        }

        if (data.isFirstTime) {
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isDuplicatePage", value: false },
            })
          );
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isMaxUser", value: false },
            })
          );
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isDuplicateProcess", value: false },
            })
          );
          const { currentUser, sipConfig } = getState().globalStateReducer;
          if (
            currentUser &&
            currentUser.phoneType == "web" &&
            State != "offline" &&
            State != "logout"
          ) {
            messageService.registerUser(
              dispatch,
              "sip",
              { sipConfig, forceOnline: false },
              getState
            );
          }
          configProcessor(`liveMonitor`);
          // configProcessor(`liveSubscriber`);
          configProcessor(`previewCont`);
          configProcessor(`recentCalls`);
          configProcessor(`pauseList`);
          configProcessor(`teamList`);
        } else if (data.isForceLogout) {
          if (State != "online") {
            apiManager.clearStorage();
            window.location.href = "/sign-in";
          }
        }
        let LastState = data.data.LastState || "";
        if (LastState == "break" || LastState == "offline") {
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "agentDashboardId", value: uuidv4() },
            })
          );
        }
      } else if (data.isUseHere) {
        let tenant = localStore.getItem("selected-tenant");
        let token = localStore.getItem("token");
        setTimeout(() => {
          localStore.setItem("selected-tenant", tenant);
          localStore.setItem("token", token);
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isConnected", value: false },
            })
          );
          messageService.destroySocket();
        }, 3000);
      } else if (data.isForceLogout) {
        setTimeout(() => {
          let State = data.data && data.data.State ? data.data.State : "";
          if (State != "online") {
            apiManager.clearStorage();
            window.location.href = "/sign-in";
          }
        }, 200);
      }
    } else if (data.type == "globalError") {
      if (data.ERROR) {
        if (data.ERROR == "TENANT_MAX_COUNT_REACH") {
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isMaxUser", value: true },
            })
          );
        } else if (data.ERROR == "SESSION_ALREADY_TAKEN") {
          dispatch(
            globalAction.dynamicUpdate({
              data: { key: "isDuplicatePage", value: true },
            })
          );
        } else if (data.ERROR == "PLEASE_SEND_ONE_STATE_AND_RESTART") {
          // dispatch(globalAction.dynamicUpdate({ data  : {"key":"isDuplicatePage",value : true } }));
          let message = {
            type: "stateHandler",
            state: "offline",
            subState: "",
            stateInfo: "",
          };
          messageService.emitSocketMessage("message-processor", message);

          setTimeout(() => {
            messageService.destroySocket();
          }, 1000);
        }
      }
      // let message = {
      //   type: 'stateHandler',
      //   state: 'offline',
      //   subState: '',
      //   stateInfo: ''
      // };
      // messageService.emitSocketMessage('message-processor', message);
      // setTimeout(() => {
      //   configProcessor(`liveMonitor`);
      //   configProcessor(`liveSubscriber`);
      //   configProcessor(`recentCalls`);
      //   configProcessor(`pauseList`);
      //   configProcessor(`teamList`);
      // },500)
    } else if (data.type == "notificationHandler") {
      messageService.notificationSocketMessage(
        dispatch,
        data.data,
        getState
        // DO NOT REMOVE THIS COMMENT
        // , data.userSession
      );
    } else if (data.type == "liveMonitor") {
      messageService.liveMonitorProcess(dispatch, data);
    }

    // setCallCustomerNumber
    // setCallCustomerName
    // setCallStartTime
    // setCallCurrentTime
    // if (data.meta.type === 'success') {
    //   const { currentChannel } = getState().channelReducer;
    //   const newData = { ...data };
    //   newData.currentChannel = currentChannel;
    //   dispatch({
    //     type: actionTypes.MESSAGE_SOCKET_RECEIVE,
    //     payload: newData
    //   });
    // } else {
    //   dispatch({
    //     type: actionTypes.ERROR_MESSAGE,
    //     payload: data.meta.message
    //   });
    // }
  },
  answerCall: (type, data) => (dispatch) => {
    messageService.answerCall();
    try {
      MessageHelper.musicPause();
    } catch (ex) { }
  },
  rejectCall: (type, data) => (dispatch) => {
    messageService.rejectCall();
  },
};



// WEBPACK FOOTER //
// src/store/action/message.action.js